import { pdfjs } from "react-pdf";

// El worker de pdf.js corre en su PROPIO realm. El polyfill de
// `Promise.withResolvers` que vive en `src/main.tsx` es del hilo principal y
// NO llega ahi: por eso ese polyfill llevaba meses desplegado y
// MB-APP-EXPRESS-X0 ("Uncaught TypeError: Promise.withResolvers is not a
// function", dentro de `pdf.worker.min.mjs`) seguia saliendo en Sentry.
//
// El worker tiene que cumplir dos invariantes, y las dos las fija
// `src/tests/utils/configurePdfWorker.test.ts`:
//
//   1. Sale del bundle, NUNCA de un CDN. pdf.js envuelve un worker
//      cross-origin en un blob que solo hace `await import(url)`, asi que no
//      hay forma de inyectarle un polyfill desde aqui; y encima deja los PDFs
//      de todos a merced de que cdnjs responda.
//   2. Es el build `legacy`, el unico que trae el polyfill de core-js DENTRO
//      del script del worker (`withResolvers:function withResolvers`). El
//      build moderno lanza el TypeError de arriba al atender `GetDocRequest`
//      —o sea al abrir un PDF— en Chrome < 119 y Safari < 17.4.
//
// `?url` resuelve contra el `pdfjs-dist` instalado, y `react-pdf` lo pinea
// EXACTO (4.8.69, sin caret), asi que libreria y worker no pueden
// desincronizarse: el worker valida `apiVersion` contra la suya y lanza
// `The API version "X" does not match the Worker version "Y"` si difieren,
// lo que dejaria sin PDF a TODOS los usuarios, no solo a los navegadores
// viejos. Copiar el worker a `public/` a mano es justo lo que abre esa
// puerta; este import la cierra.
import pdfWorkerUrl from "pdfjs-dist/legacy/build/pdf.worker.min.mjs?url";

/**
 * URL del script del worker de pdf.js, emitido como asset por Vite.
 */
export const PDF_WORKER_URL: string = pdfWorkerUrl;

/**
 * Apunta pdf.js al worker del bundle. Hay que llamarla antes de renderizar
 * cualquier `<Document>` de react-pdf (se hace una vez en `src/main.tsx`).
 */
export function configurePdfWorker(): void {
  pdfjs.GlobalWorkerOptions.workerSrc = PDF_WORKER_URL;
}
